export default __webpack_public_path__ + "assets/models/7cc13b579c22a948024c2e7caf1ec9e3.glb";